export default "__VITE_ASSET__BDd2YEPv__"